import ReserveBlock from './components/ReserveBlock';
import ButtonYellow from './components/ButtonYellow';
import Calculator from './components/Calculator';
import { useTranslation } from 'react-i18next';
import WhyUsCard from './components/WhyUsCard';
import Reviews from './components/Reviews';
import Header from './components/Header'
import Footer from './components/Footer'
import Routes from './components/Routes';
import Photos from './components/Photos';
import Bikes from './components/Bikes';
import bg_video from "./img/bg.webm"
import arrow from "./img/arrow.png"
import { useState, useEffect} from 'react';
import './css/mobile.css'
import { getText } from './getText';
import './App.css';
import { getInformation } from './getInformation';
import { useMemo } from 'react';
import { Analytics } from "@vercel/analytics/react"
import { useNavigate, useLocation } from "react-router-dom";

function App() {
  const [text, setText] = useState({})
  const { t, i18n } = useTranslation();
  let lang = i18n.language
  const [information, setInformation] = useState({})
  const [loading, setLoading] = useState(true)
  
    const navigate = useNavigate();
    const location = useLocation();

  const [visibleOverlay, setVisibleOverlay] = useState(true);
  const [showForm, setShowForm] = useState(false)
  useEffect(() => {
    Promise.all([getText(), getInformation()]).then(([t, i]) => {
      setText(t)
      setInformation(i)
      setTimeout(() => {setLoading(false)}, 1000)
    })
  }, [])

  const why_us_cards = useMemo(() => {
    return getWhyUsCards(text, lang)
  }, [text, lang])

  if (loading || false) return (<div className='loading_main'><span>B.R.V.</span></div>)
  return (
    <div>
    {text ? (<div className="App">
      <div className={showForm ? "background opacity" : "background"}></div>
      <Header text={text} lang={lang} i18n={i18n} t={t} />
        <div className={`block_1`} id="start">
          <div className={`overlay ${visibleOverlay ? "" : "hide"}`}></div>
          <h1
            dangerouslySetInnerHTML={{
              __html: text?.["title_1"]?.[lang].replace("CUBE 2026", "<br />CUBE 2026<br />")
            }}
          />
          <p>{text["subtitle_1"]?.[lang]}</p>
          <div style={{display: "flex", margin: "auto", width: "max-content", gap: "1rem", marginTop: 20}}>
            <ButtonYellow text={text["book_now"][lang]}/>
            <div className='button_transparent'
              onClick={() => {scrollToId(navigate, location, 'routes')}}
            >
              {text["features"]?.[lang]}
            </div>
          </div>
          <img className="arrow" src={arrow} alt="" onClick={() => {scrollToId(navigate, location, 'fleet')}} />
          
          <video  autoPlay
          muted
          loop
          playsInline
          className="hero-vid"
          preload="none"
          onCanPlay={() => {setVisibleOverlay(false)}}>
            {/* <source src={bg_video_mp4} type="video/mp4" /> */}
            <source src={bg_video} type="video/webm" />
          </video>
        </div>
        <Routes text={text} lang={lang} i18n={i18n} />
        <Bikes text={text} lang={lang} i18n={i18n}/>
        <ReserveBlock information={information} text={text} lang={lang} showForm={showForm} setShowForm={setShowForm} />
        <div className='block_6' id="why_us">
          <h3>{text["title_6"]?.[lang]}</h3>
          <h6>{text["subtitle_6"]?.[lang]}</h6>
          <div>
            {why_us_cards.map(card => <WhyUsCard img={card.img} title={card.title} subtitle={card.subtitle} />)}
          </div>
          <div>
            <div>
              <div>{text['included_with_every_rental']?.[lang]}</div>
              <div>{text['premium_helmet']?.[lang]}</div>
            </div>
            <div>
              <ButtonYellow text={text['book_now']?.[lang]}/>
            </div>
          </div>
        </div>
        <Reviews text={text} lang={lang} i18n={i18n}/>
        <Calculator text={text} lang={lang} />
        <Photos text={text} lang={lang} t={t} />
        <Footer information={information} text={text} lang={lang}  />
        <Analytics />
    </div>) : (<div></div>)}</div>
  );
}


export const getWhyUsCards = (text, lang) => {
  console.log(text)
  if (text || true){

    return [
      {
        img: "why_us_card_0.svg",
        title: text["card_1_title"]?.[lang] || "",
        subtitle: text["card_1_subtitle"]?.[lang] || "",
      },
      {
        img: "why_us_card_1.svg",
        title: text["card_2_title"]?.[lang] || "",
        subtitle: text["card_2_subtitle"]?.[lang] || "",
      },
      {
        img: "why_us_card_2.svg",
        title: text["card_3_title"]?.[lang] || "",
        subtitle: text["card_3_subtitle"]?.[lang] || "",
      },
      {
        img: "why_us_card_3.svg",
        title: text["card_4_title"]?.[lang] || "",
        subtitle: text["card_4_subtitle"]?.[lang] || "",
      },
      {
        img: "why_us_card_4.svg",
        title: text["card_5_title"]?.[lang] || "",
        subtitle: text["card_5_subtitle"]?.[lang] || "",
      },
      {
        img: "why_us_card_5.svg",
        title: text["card_6_title"]?.[lang] || "",
        subtitle: text["card_6_subtitle"]?.[lang] || "",
      },
    ]
  }
  else{
    return []
  }
}

export const scrollToId = (navigate, location, to_id) => {
  const lang = location.pathname.split("/")[1];

  const isRootLangPage = location.pathname === `/${lang}`;
  // console.log('isRootLangPage')
  // console.log(isRootLangPage)
  if (!isRootLangPage) {
    navigate(`/${lang}`);

    setTimeout(() => {
      const element = document.getElementById(to_id);

      if (element) {
        window.scrollTo({
          top: element.offsetTop - 80,
          behavior: "smooth",
        });
      }
    }, 100);

    return;
  }

  const element = document.getElementById(to_id);

  if (element) {
    window.scrollTo({
      top: element.offsetTop - 80,
      behavior: "smooth",
    });
  }
}

export default App;